import React, { Component } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { VendorAddressPopUp } from '../components/VendorAddressPopUp';
import { Link } from 'react-router-dom';
import { Loading } from '../components/Loading';
import CommonUtils from '../utils/siteUtils.js';
import ServiceCalls from '../utils/serviceCalls.js';
import RoleUtils from '../utils/roleUtils.js';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import '../styles/Vendor.css';

export class VendorAddresses extends Component {

    constructor(props) {
        super()
        this.handleClose = this.handleClose.bind(this);
        this.getVendorCountries.bind(this);
        this.buildTable = this.buildTable.bind(this);
        this.onChange = this.onChange.bind(this);
        this.state = {
            isLoading: true,
            isReadOnly: true,
            vendorData: {},
            countryData: []
        }
    }

    componentDidMount() {
        this.getVendorCountries(this.props.vendorData);
    }

    getVendorCountries(vendorData) {
        const { currentCompanyId, currentUser } = this.props;
        var readOnly = (this.props.vendorData.enabled === false) || (RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.profileEditNoBankRoles()) === false);
        // 	DE774176: Dynamic City & State Label
        const array = vendorData.vendorAddresses;
        const flag = array.some(item => item.country !== "USA");
        if (flag) {
            if (this.state.countryData.length === 0) {
                console.log("Fetching countries for remit");
                ServiceCalls.getVendorCountries()
                    .then(countries => {
                        if (countries) {
                            this.setState({
                                isLoading: false,
                                countryData: countries,
                                vendorData: vendorData,
                                isReadOnly: readOnly
                            });
                        }
                        else {
                            this.setState({
                                isLoading: false,
                                isReadOnly: true
                            });
                        }
                    })
            }
            else {
                console.log("Already have country data " + this.state.countryData.length);
                this.setState({
                    isLoading: false,
                    vendorData: vendorData,
                    isReadOnly: readOnly
                });
            }
        }
        else {
            this.setState({
                isLoading: false,
                vendorData: vendorData,
                isReadOnly: readOnly
            });
        }
    }

    onChange() {
        const { currentCompanyId } = this.props;
        this.setState({
            isLoading: true,
        });

        ServiceCalls.getVendorInfo(Number(currentCompanyId)).then(function (results) {
            if (results) {
                this.getVendorCountries(results);
            }
        }.bind(this));
    }

    //Handle close method for confirmModal
    handleClose() {
        this.setState({ statusChange: false });
    }


    buildTable() {
        /*const { currentUser, currentCompanyId } = this.props;*/
        const { isReadOnly, vendorData, countryData } = this.state;
        var addresses = (vendorData.vendorAddresses) ? vendorData.vendorAddresses : [];
        //US7579449 - update Helper text on disabled 'Inactivate' button for ALL suppliers
        var inactivateBtnText = "This is a system default address, please reach out via the Contact Us page for assistance.";
        if (addresses.length > 0) {
            //Sort Array by Address SEQ
            addresses = CommonUtils.sortRemitAddresses(addresses);

            //Only show 4 addresses
            const limitedArr = addresses.slice(0, 4);

            var addressRow = limitedArr.map(function (item, idx) {
                // 	DE774176: Dynamic City & State Label
                var regionLabel;
                var cityLabel;
                if (item.country === "USA") {
                    regionLabel = "State";
                    cityLabel = "City";
                }
                else {
                    var countryObj = countryData.find(country => country.country === item.country);
                    regionLabel = (countryObj.stateAvailable === "N") ? '' : CommonUtils.determineVendorContactRegionLabel(countryObj);
                    cityLabel = CommonUtils.determineVendorContactCityLabel(countryObj);
                }

                //If Address is InActive. Show as read only
                var isAddressActive = true;
                if (item.effStatus !== 'A') {
                    isAddressActive = false;
                }
                //Check if Default
                var isDefaultAddress = item.defaultAddress === 'Y';

                var address1 = (item.address1.trim()) ? item.address1 : <span>&nbsp;</span>;
                var address2 = (item.address2.trim()) ? item.address2 : <span>&nbsp;</span>;
                var address3 = (item.address3.trim()) ? item.address3 : <span>&nbsp;</span>;

                var actionBtns = (isAddressActive)
                    ? (isReadOnly)
                        ? (isDefaultAddress)
                            ? <></>
                            //Remove based on biz feedback
                            // <div className="contactBtns">
                            //    <div id="remitAddDefault"><FontAwesomeIcon id="font-awesome-sqCheck" className="primaryIcon" size="2x" icon={faSquareCheck} /> Default Remit Address</div>
                            // <Button className="vContactBtn" disabled={true} title={inactivateBtnText} >Inactivate</Button>
                            //Hiding action buttons for Read Only users                            
                            //</div>
                            : <></>
                        : (isDefaultAddress)
                            ? <div className="contactBtns">
                                {/*<div id="remitAddDefault"><FontAwesomeIcon id="font-awesome-sqCheck" className="primaryIcon" size="2x" icon={faSquareCheck} /> Default Remit Address</div>*/}
                                <VendorAddressPopUp currentAddress={item} vendorData={vendorData} allAddresses={addresses} editMode="Edit" onAddressChange={this.onChange} />
                                <OverlayTrigger
                                    overlay={<Tooltip>{inactivateBtnText}</Tooltip>}>
                                    <span>
                                        <Button className="vContactBtn" disabled={true}>Inactivate</Button>
                                    </span>
                                </OverlayTrigger>
                                
                            </div>
                            : <div className="contactBtns">
                                <VendorAddressPopUp currentAddress={item} vendorData={vendorData} allAddresses={addresses} editMode="Edit" onAddressChange={this.onChange} />
                                <VendorAddressPopUp currentAddress={item} vendorData={vendorData} allAddresses={addresses} editMode="Inactivate" onAddressChange={this.onChange} />
                                {/*<VendorAddressPopUp currentAddress={item} vendorData={vendorData} allAddresses={addresses} editMode="SetDefault" onAddressChange={this.onChange} /> */}
                            </div>
                    : <div className="inactivateAddRow">
                        <div className="inactivateAdd">Inactive</div>
                    </div>;

                return (

                    <Col key={idx} sm={3} className='addressColumn'>
                        <div className='addressLabels'>Address</div>
                        <div className="contactField">{address1}</div>
                        <div className="contactField">{address2}</div>
                        <div className="contactField">{address3}</div>

                        <div className='contactsLocationContainer'>
                            <div className='contactsLocationItem'>
                                <div className='addressLabels'>{cityLabel}</div>
                                <div className="contactField">{item.city}</div>
                            </div>

                            <div className='contactsLocationItem'>
                                <div className='addressLabels'>{regionLabel}</div>
                                <div className="contactField">{item.stateProvince}</div>
                            </div>

                            <div className='contactsLocationItem'>
                                <div className='addressLabels'>Postal</ div>
                                <div className="contactField">{item.postalCode}</div>
                            </div>

                        </div>

                        <div className='addressLabels'>Country</div >
                        <div className="contactField">{item.country} </ div >
                        {actionBtns}
                    </Col>
                );
            }.bind(this));
            return (<Row>{addressRow}</Row>);
        }
        else {
            return (<Col><h4>No Remit Addresses</h4></Col>);
        }

    }

    render() {
        //<ConfirmModal message={msg} handleAccept={this.updateAdminInfo} isOpen={this.state.statusChange} handleClose={this.handleClose} />
        const { vendorData, isReadOnly, isLoading } = this.state;
        var addresses = (vendorData.vendorAddresses) ? vendorData.vendorAddresses : [];
        var maxItems = (addresses.length > 4) ? 4 : addresses.length;
        //US7579449 - EMEA+ View - Address
        var isEMEASupplier = (vendorData)?CommonUtils.determineIfVendorIsEMEAPlus(vendorData):false;
        //US7579449 - Hide View More from EMEA+
        var showMoreDisp = (addresses.length > 4) ?
            <Link to="/Profile/Supplier/RemitAddresses">
                <span>Show More </span>
            </Link> : <></>;
        //US7579449 - Hide Add from EMEA+
        var addBtn = (isReadOnly || isEMEASupplier) ? <></> : <VendorAddressPopUp currentAddress={null} vendorData={vendorData} allAddresses={addresses} editMode="Add" btnClassName="right" onAddressChange={this.onChange} />;
        var display = (isLoading)
            ? <div style={{ margin: "auto", width: "100px" }}>
                <Loading />
            </div>
            : this.buildTable();
 
        return (
            <>              
              <Container fluid>
                    <Row className="access-headers">
                        <Col xs={2}><h3>Remit Addresses</h3></Col>
                        <Col xs={{ span: 2, offset: 7}}>                            
                            <div className="vendorPagination"><span>Displaying 1 - {maxItems} of {addresses.length}</span>&nbsp;&nbsp;&nbsp;{showMoreDisp}</div>
                        </Col>
                        <Col xs={1}>
                            {addBtn}
                        </Col>
                    </Row>
                </Container>
                <Container fluid className="vendorArea border-left-dark shadow borderCurve lastVendorSection">
                    {display}
                </Container>
            </>
        )
    }
}